import { render, staticRenderFns } from "./gasStat.vue?vue&type=template&id=4cb975ce&scoped=true"
import script from "./gasStat.vue?vue&type=script&lang=js"
export * from "./gasStat.vue?vue&type=script&lang=js"
import style0 from "./gasStat.vue?vue&type=style&index=0&id=4cb975ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb975ce",
  null
  
)

export default component.exports